export default __webpack_public_path__ + "static/media/quiz-q3.dd849369.png";